/* Only registered editorial media inside TeeInBlue's popup gallery; no product or design mutation. */
(() => {
  const node=document.getElementById('uws-popup-media-registry');if(!node)return;
  let groups;try{groups=JSON.parse(node.textContent)}catch{return}
  const byFile=new Map();
  function filename(value){
    try {const url=new URL(value,location.href);if(url.hostname!=='cdn.shopify.com'&&url.hostname.replace(/^www\./,'')!==location.hostname.replace(/^www\./,''))return null;return decodeURIComponent(url.pathname.split('/').pop())}catch{return null}
  }
  for(const group of groups){
    for(const value of [...Object.values(group.files||{}),...Object.values(group.urls||{})]){
      if(typeof value!=='string'||!value)continue;
      byFile.set(value.includes('/')?filename(value):value,group);
    }
  }
  function translated(value,locale){
    const name=filename(value);if(!name)return value;
    const group=byFile.get(name)||byFile.get(name.replace(/_\d+x\d*(?:_crop_[a-z]+)?(?=\.[^.]+$)/,''));
    if(!group)return value;
    const target=group.urls?.[locale]||group.urls?.en;if(!target)return value;
    try {const destination=new URL(target,location.href),original=new URL(value,location.href);const width=original.searchParams.get('width');if(width&&/^\d+$/.test(width))destination.searchParams.set('width',width);return destination.href}catch{return value}
  }
  function update(){
    const locale=((location.pathname.match(/^\/(de|en|fr|es|it)(?:-[a-z]{2})?(?=\/|$)/i)||[])[1]||'de').toLowerCase();
    document.querySelectorAll('.tee-cross-sell-product-popup .tee-cross-sell-product__gallery img, .tee-cross-sell-product-popup .tee-cross-sell-product__gallery source, .tee-cross-sell-product-popup .tee-cross-sell-product__gallery a[href]').forEach(el=>{
      for(const attr of ['src','data-src','data-original','href']){const old=el.getAttribute(attr);if(!old)continue;const next=translated(old,locale);if(next!==old)el.setAttribute(attr,next)}
      for(const attr of ['srcset','data-srcset']){const old=el.getAttribute(attr);if(!old)continue;let changed=false;const next=old.split(',').map(part=>{const m=part.trim().match(/^(\S+)(\s+.+)?$/);if(!m)return part;const url=translated(m[1],locale);if(url!==m[1])changed=true;return url+(m[2]||'')}).join(', ');if(changed)el.setAttribute(attr,next)}
    });
  }
  let pending=false;function schedule(){if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;update()})}
  new MutationObserver(schedule).observe(document,{subtree:true,childList:true,attributes:true,attributeFilter:['src','srcset','data-src','data-srcset','data-original','href','lang']});
  update();
})();
